import React from 'react';
import SIcon from './SIcon';
import { faStopCircle } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faStopCircle} fa />;

export default Icon;
